import { catchError } from 'rxjs/operators';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractHttpService } from './http-abstract.service';
import { CapInfo, ConfigDto, DmsLocationDto, ServiceSelectionDto } from './dtos';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class HttpConfigService extends AbstractHttpService {
	constructor(http: HttpClient) {
        super(http);
    }

    getConfig(): Observable<ConfigDto> {
        return super.get('/config/service');
    }

	getAreas(areaId: number): Observable<Array<DmsLocationDto>> {
        return super.get(`/config/area/${areaId}`);
    }

	getCapInfo(capId: number): Observable<CapInfo> {
        return super.get(`/config/cap/${capId}`);
    }

}